import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { getFormattedDateTime } from "utils/helper";

const formatLocationLabel = (loc) => {
  if (loc === "Advanced Charting") return "PreCharting";
  return loc;
};

const ErrorHistoryDialog = ({ open, onClose, history = [] }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: 3,
        },
      }}
    >
      <DialogTitle>Error Details History</DialogTitle>

      <DialogContent dividers>
        {!history.length ? (
          <Typography fontSize={14}>No error history available.</Typography>
        ) : (
          <Box>
            {history.map((entry, index) => (
              <Box key={index} mb={3}>
                {entry.type === "No" ? (
                  <Box>
                    <Typography fontSize={14} fontWeight={600}>
                      No error found by {entry.created_by} on{" "}
                      {getFormattedDateTime(entry.created_at)}
                    </Typography>

                    {entry.no_error_reason ? (
                      <Typography fontSize={13} mt={1}>
                        <strong>Reason:</strong> {entry.no_error_reason}
                      </Typography>
                    ) : null}

                    {entry.additional_notes ? (
                      <Typography fontSize={13} mt={1}>
                        <strong>Note:</strong> {entry.additional_notes}
                      </Typography>
                    ) : null}
                  </Box>
                ) : (
                  <Box>
                    <Typography fontSize={14} fontWeight={600}>
                      Error(s) found by {entry.created_by} on{" "}
                      {getFormattedDateTime(entry.created_at)}
                    </Typography>

                    {Array.isArray(entry.error_locations) &&
                      entry.error_locations.map((loc) => (
                        <Box key={loc} mt={1.5}>
                          <Typography fontSize={13} fontWeight={600}>
                            Error location: {formatLocationLabel(loc)}
                          </Typography>

                          <Typography fontSize={13} fontWeight={600} mt={1}>
                            Error Category:
                          </Typography>

                          {Array.isArray(entry?.reasons_by_location?.[loc]) &&
                          entry.reasons_by_location[loc].length > 0 ? (
                            entry.reasons_by_location[loc].map(
                              (reason, idx) => (
                                <Typography
                                  key={idx}
                                  fontSize={13}
                                  sx={{ pl: 1 }}
                                >
                                  {reason}
                                </Typography>
                              ),
                            )
                          ) : (
                            <Typography fontSize={13} sx={{ pl: 1 }}>
                              -
                            </Typography>
                          )}

                          {entry?.notes_by_location?.[loc] ? (
                            <Typography fontSize={13} mt={1}>
                              <strong>Note:</strong>{" "}
                              {entry.notes_by_location[loc]}
                            </Typography>
                          ) : entry?.additional_notes ? (
                            <Typography fontSize={13} mt={1}>
                              <strong>Note:</strong> {entry.additional_notes}
                            </Typography>
                          ) : null}
                        </Box>
                      ))}
                  </Box>
                )}

                {index !== history.length - 1 && (
                  <Box
                    sx={{
                      borderBottom: "1px dashed #999",
                      mt: 2,
                      pt: 1,
                    }}
                  />
                )}
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorHistoryDialog;
